import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "react-query";

import { staticDropdownValuesService } from "services";

import { withFeeBlockContext } from "../../feeBlockContext";
import TemplateField from "../../templateField";

const FeeSecondaryBlock = ({ validators, isPaperApplication }) => {
	const { data: feeMonths } = useQuery(
		"feeMonths",
		staticDropdownValuesService.getMonths,
	);

	return (
		<>
			<Row>
				<Col md={5}>
					<TemplateField
						name="applicationFee"
						label="Application Fee, $"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						{...validators.applicationFee}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<TemplateField
						name="annualFee"
						label="Annual Fee, $"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						{...validators.annualFee}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={5}>
					<TemplateField
						name="earlyTerminationFee"
						label="Early Termination Fee, $"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						{...validators.earlyTerminationFee}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<TemplateField
						name="monthAnnualFeeBilled"
						label="Month Annual Fee Billed"
						items={feeMonths}
						{...validators.monthAnnualFeeBilled}
						type="dropdown"
						useFirstAsDefault
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
			</Row>
		</>
	);
};

export default withFeeBlockContext("FeeSecondary")(FeeSecondaryBlock);
